import {ICompanyLogin, IMessageData} from "../../../index";
import {ErrorTracker} from "../../../error.tracker";

export interface IFormData {
    et: ErrorTracker,
    isReady: KnockoutObservable<boolean>
    messageData: KnockoutObservable<IMessageData>
    mobile: KnockoutObservable<string>
    selectedOrg: KnockoutObservable<ICompanyLogin>
    ssn: KnockoutObservable<string>
    username: KnockoutObservable<string>
}
